import { Component, ChangeDetectionStrategy } from '@angular/core';

import { BtnActionComponent } from '../btn-action/btn-action.component';

@Component({
    selector: 'aa-btn-action-warning',
    templateUrl: '../btn-action/btn-action.component.html',
    styleUrls: [
        '../btn-action/btn-action.component.scss',
        './btn-action-warning.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BtnActionwarningComponent extends BtnActionComponent
{
    constructor ()
    {
        super();
    }
}
